export default __webpack_public_path__ + "static/media/2237.ebc2c1e7.png";